import { urlBaseAccreditation } from "../../config/";
import axiosInstance from "../../../services/config/axiosinstance";
import FaceRecognitionAwsReportModel from '../../../models/FaceRecognitionAwsReportModel';

export default async function getGuestsByAwsFaceIds(
  eventId = '',
  limit = 10,
  offset = 0,
  search = '',
  filter = '',
) {
  try {
    const _config = {
      method: 'GET',
      url: `${urlBaseAccreditation}/awsFaceReport/getGuestsByAwsFaceIds?eventId=${eventId}&limit=${limit}&offset=${offset}&search=${search}&filter=${filter}`,
      headers: {
        "Content-Type": "application/json",
      },
    };

    const _ret = await axiosInstance(_config);

    if (!_ret.data.success) {
      throw new Error(_ret.data.message);
    }

    let _return = {
      data: [],
      count: _ret.data.data.count,
    };
    for (let i = 0; i < _ret.data.data.data.length; i++) {
      _return.data.push(FaceRecognitionAwsReportModel(_ret.data.data.data[i]));
    }

    return _return;
  } catch (error) {
    console.log('Error getGuestsByAwsFaceIds', error);
    throw error;
  }
}
